import { useSearchParams } from "react-router-dom";
import GearMark from "@/components/GearMark";
import { APPS } from "@/config";

const [APP1] = APPS;

function Orbit() {
  return (
    <div className="relative flex h-full w-full items-center justify-center">
      <svg viewBox="0 0 600 600" className="absolute h-[560px] w-[560px]">
        <circle cx="300" cy="300" r="120" fill="none" stroke="#E8E4DD" strokeWidth="1.5" />
        <circle cx="300" cy="300" r="190" fill="none" stroke="#A9C7DD" strokeWidth="1.2" strokeDasharray="5 10" />
        <circle cx="300" cy="300" r="260" fill="none" stroke="#E8E4DD" strokeWidth="1" strokeDasharray="2 14" />
        <line x1="60" y1="300" x2="540" y2="300" stroke="#A9C7DD" strokeWidth="1" strokeDasharray="1 10" opacity="0.6" />
        <line x1="300" y1="60" x2="300" y2="540" stroke="#A9C7DD" strokeWidth="1" strokeDasharray="1 10" opacity="0.6" />
      </svg>
      <GearMark size={210} className="drop-shadow-[0_24px_50px_rgba(214,53,10,0.4)]" />
      <span className="absolute left-[8%] top-[16%] rounded-xl border border-line bg-white/90 px-4 py-2.5 font-mono text-[11px] font-semibold uppercase tracking-[0.16em] text-ink shadow-sm">
        AWS Marketplace
      </span>
      <span className="absolute right-[2%] top-[40%] rounded-xl border border-line bg-white/90 px-4 py-2.5 font-mono text-[11px] font-semibold uppercase tracking-[0.16em] text-ink shadow-sm">
        Private offers
      </span>
      <span className="absolute bottom-[14%] left-[16%] rounded-xl border border-line bg-white/90 px-4 py-2.5 font-mono text-[11px] font-semibold uppercase tracking-[0.16em] text-ink shadow-sm">
        Partner channel
      </span>
    </div>
  );
}

export default function OgCard() {
  const [params] = useSearchParams();
  const app = APPS.find((a) => a.id === params.get("app"));

  return (
    <div className="relative h-[630px] w-[1200px] overflow-hidden bg-paper">
      <div className="blueprint-grid pointer-events-none absolute inset-0 opacity-70" />
      <div className="pointer-events-none absolute inset-8 border border-bluerule/50" />
      <span className="pointer-events-none absolute left-4 top-4 font-mono text-lg text-line">+</span>
      <span className="pointer-events-none absolute right-4 top-4 font-mono text-lg text-line">+</span>
      <span className="pointer-events-none absolute bottom-4 left-4 font-mono text-lg text-line">+</span>
      <span className="pointer-events-none absolute bottom-4 right-4 font-mono text-lg text-line">+</span>

      {app ? (
        <div className="relative flex h-full flex-col justify-between py-20 pl-16 pr-16">
          <div className="flex items-center gap-3">
            <GearMark size={44} />
            <span className="font-display text-2xl font-extrabold tracking-tight text-ink">Transactr</span>
            <span className="ml-4 rounded-full border border-line bg-white px-4 py-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-inksoft">
              {app.loginLabel}
            </span>
          </div>
          <div className="max-w-[920px]">
            <h1 className="font-display text-[50px] font-extrabold leading-[1.08] tracking-[-0.02em] text-ink">
              {app.name.split(" ").slice(0, -1).join(" ")}{" "}
              <em className="font-accent text-[1.2em] font-medium italic text-vermillion">
                {app.name.split(" ").pop()}
              </em>
            </h1>
            <p className="mt-6 max-w-[780px] text-xl leading-snug text-inksoft">{app.tagline}</p>
          </div>
          <div className="flex items-center justify-between font-mono text-[13px] uppercase tracking-[0.18em] text-inksoft">
            <span>trxtr.io</span>
            <span className="text-vermillion">Sign in — {app.loginUrl.replace("https://", "")}</span>
          </div>
        </div>
      ) : (
        <div className="relative grid h-full grid-cols-[1.1fr_0.9fr] items-center gap-8 py-16 pl-16 pr-12">
          <div>
            <div className="flex items-center gap-3">
              <GearMark size={44} />
              <span className="font-display text-2xl font-extrabold tracking-tight text-ink">Transactr</span>
            </div>
            <h1 className="mt-8 font-display text-[46px] font-extrabold leading-[1.08] tracking-[-0.02em] text-ink">
              Autonomous workflows for{" "}
              <em className="font-accent text-[1.2em] font-medium italic text-vermillion">upselling</em> in the AWS
              Marketplace.
            </h1>
            <p className="mt-6 text-xl leading-snug text-inksoft">
              A buyer page branded as your own — then private offers on autopilot.
            </p>
            <p className="mt-10 font-mono text-[13px] uppercase tracking-[0.18em] text-inksoft">
              trxtr.io · Book a demo with the founder
            </p>
          </div>
          <div className="h-full py-6">
            <Orbit />
          </div>
        </div>
      )}
    </div>
  );
}
